import type { LayoutLoad } from './$types';
import { browser } from '$app/environment';
import { captureAttribution } from '@allibee/utils';
import { auth, session } from '$stores/auth';
import { master } from '$stores/master';
import { get } from 'svelte/store';
import { PUBLIC_BUILD_NAME } from '$env/static/public';
import { themeStore } from '$stores/theme';

// root의 layout load 는 페이지 이동시 항상 실행이 됨
export const load: LayoutLoad = async ({ url, parent }) => {
    // UTM·광고 어트리뷰션 캡처 (ALLIBEE-356) — 하위 layout의 auth 부트스트랩(setPostHogUser)보다 먼저 실행돼야
    // 이미 로그인된 유저의 첫 identify에도 first-touch가 부착된다. onMount는 load 이후라 여기서 캡처.
    // captureAttribution은 여러 번 불려도 안전 (first는 유지, last는 광고 파라미터 있을 때만 갱신).
    if (browser) captureAttribution(url, document.referrer);
    await parent();
    const { pathname } = url;
    const isDemo = PUBLIC_BUILD_NAME === 'demo_allibee';
    const isDev = __IS_DEV_SERVER_ENV__;

    return {
        pathname,
        isDemo,
        isDev,
        master: get(master),
        auth: get(auth),
        session: get(session),
        title: 'allibee',
        themeConfig: get(themeStore),
    };
};

export const prerender = 'auto';
export const ssr = true;
// export const trailingSlash = 'always';
export const trailingSlash = 'ignore';
